<template>
    <div style="display: inline-block;">
        <ColorPicker v-model="text" :inline="inline" :disabled="disabled" :format="colorFormat" />
    </div>
</template>

<script>
import { computed } from 'vue'
import ColorPicker from 'primevue/colorpicker';

export default {
    name: 'tw-color-picker', //颜色选择器
    components: {
        ColorPicker
    },
    setup(props, context) {
        const text = computed({
            get() {
                return (props.modelValue === null || props.modelValue === undefined) ? "" : props.modelValue
            },
            set(value){
                context.emit('update:modelValue', value)
            }
        })

        return {
            text,
        }
    },
    props: {
        modelValue: String,
        inline: Boolean,
        colorFormat: String,
        disabled: Boolean,
    }
}
</script>
